import m, {Vnode} from "mithril";
import {Questionary} from "../../../../model/questionary";
import {SliderItem} from "../../../../model/items/slider";

export default class SliderCell {

    private readonly questionary: Questionary;

    constructor(
        public readonly slider: SliderItem
    ) {
        this.questionary = slider.cell.grid.questionary;
    }

    public view(): Vnode|null {

        if (!this.slider.cell.visible) {
            return null;
        }

        const cssClass = 'sliderCell'
            + (this.slider.cell.cssClass ? (' '+this.slider.cell.cssClass) : '')
            + (this.slider.cell.enabled ? ' .enabled' : ' .disabled')
        ;

        return m(".", {
            "class": cssClass,
        }, this.slider.getView());
    }
}